<app-header></app-header>

<div class="image-container">
  <img src="assets/navimage.png" width="100%" alt="Your Image">
  <div class="image-text">
    <p>People Behind the Vision</p>
  </div>
</div>

<div class="bg-white" style="height: 15vh;">

</div>

<div class="container-fluid behind">
  <div class="section-heading">
    <u>People Be</u>hind the Vision
  </div>

  <!-- Chairman Section -->
  <div class="row align-items-center message-row" id="Chairman">
    <div class="col-lg-7 col-12 order-1"> 
      <div class="message-title">Chairman's Message</div> 
      <div class="message-text">
        Dear Parents and Students, <br />
        A person's life shines and flourishes only through education. It is the foundation of a happy and meaningful existence. Education leads us to economic stability, social development, and scientific progress — not just for the individual, but for the nation and humanity at large.<br />
        Education makes us creative and helps shape multi-dimensional personalities within society. Since ancient times, schools have been an indispensable part of the social fabric. There has always been a symbiotic relationship between schools and society — society supports schools, and in return, schools nurture and uplift society. Unfortunately, in recent times, this strong bond has weakened.<br />
        In Bihar, institutions like Nalanda University once drew scholars from across the globe, reminding us of our rich educational legacy. It is a well-established fact that the true parameter of a society’s development is the quality of education it provides. We cannot imagine our existence without education. It is through education that we create complete human beings.<br />
        When we face challenges, we may feel weak for a moment — but within us exists a restlessness, a desire to act.

        <span *ngIf="!showChairmanMessage"></span>
        <span *ngIf="showChairmanMessage">
          <br />
          This feeling of unrest — the urge to contribute to society — should exist in every individual. And it is education that awakens this spirit within us.<br />
          For this noble cause, Progressive Central High School, Patsa, located in the rural heart of Mithilanchal, has been striving for many years to provide quality education to the talented youth of the region. It has helped students realize their highest dreams and aspirations.<br />
          Our school, located in Hasanpur, Samastipur, truly lives up to its name by continuously pushing for the progress of this area. A team of visionary, energetic, and efficient educators and staff — along with a proactive management body — are working tirelessly to adapt to modern teaching methods and pedagogy. We aim to cultivate scientific thinking and a rational approach in our students.<br />
          As a result, our alumni have proven themselves across diverse fields — whether in science and technology, arts and culture, sports, management, or leadership. They shine like stars at every level of professional life.<br />
          We are deeply thankful to our dedicated teachers, hardworking staff, and the supportive community we belong to. Our teachers are highly educated, enthusiastic, and committed to their profession.<br />
          The school is well-equipped with modern educational tools — including a rich library, fully functional science labs for Biology, Physics, Chemistry, and Mathematics, as well as a Music room. Our computer lab is another major asset that caters to students' everyday learning needs.<br />
          We firmly believe in both scholastic and co-scholastic development to nurture complete individuals. Discipline, in our view, is developed through impression and experience, and so we walk alongside our students in the journey of learning.<br />
          As a co-educational institution, we ensure equal opportunities for both boys and girls, working without any discrimination of caste, creed, or religion.<br />
          We remain hopeful and committed to becoming even more valuable to the society we proudly serve.
        </span>

        <a (click)="showChairmanMessage = !showChairmanMessage" class="read-more-link">
          {{ showChairmanMessage ? '(Read Less)' : '...(Read More)' }}
        </a>
        <!-- <div class="mt-2">Warm Regards,</div> -->
      </div>
      <!-- <div style="padding-left: 5%;">
        <img src="assets/sign_dir.png" alt="">
      </div> -->
    </div>
    <div class="col-lg-5 col-12 order-2 text-center">
      <img class="profile-img" src="assets/Homepage/director.jpg" alt="Chairman" />
      <div class="person-name">Ramnandan Singh <br />(Chairman)</div>
    </div>
  </div>


  <!-- Director Section -->
  <div class="row align-items-center message-row" id="director">
    <div class="col-lg-7 col-12 order-lg-2 order-1">
      <div class="message-title">Director's Message</div>
      <div class="message-text">
        Dear Parents and Students, <br />
        Education is not merely a tool for academic excellence but a powerful means of transforming lives. At Progressive Central High School, Patsa, we firmly believe in nurturing the innate talents of every child and instilling in them a lifelong passion for learning and growth.
        Our commitment has always been to create a nurturing, inclusive, and progressive learning environment where students feel inspired and empowered to shape their own future. In today’s rapidly changing world, we must prepare our children not only with knowledge, but with values, adaptability, and a sense of responsibility toward society.
        <span *ngIf="!showDirectorMessage"></span>
        <span *ngIf="showDirectorMessage">
          <br />
          We focus on holistic development — balancing academics with co-curricular and life skill education. Our dedicated team of teachers, well-equipped infrastructure, and a vision-driven management ensure that every student receives the guidance and support they need to thrive.
          <br />
          Let us continue this journey together, committed to excellence, compassion, and innovation — building a generation ready to contribute meaningfully to the nation and the world.
          <br />
          Thank you for placing your trust in us.
        </span>
        <a (click)="showDirectorMessage = !showDirectorMessage" class="read-more-link">
          {{ showDirectorMessage ? '(Read Less)' : '...(Read More)' }}
        </a>
      </div>
      <!-- Optional signature -->
      <!-- <div style="padding-left: 5%;">
        <img src="assets/sign_dir.png" alt="Director Signature">
      </div> -->
    </div>
    <div class="col-lg-5 col-12 order-lg-1 order-2 text-center">
      <img class="profile-img" src="assets/Homepage/director-vs.jpg" alt="Director" />
      <div class="person-name">Veena singh <br />(Director)</div>
    </div>
  </div>


  <!-- Principal Section -->
  <div class="row align-items-center message-row" id="principal">
    <div class="col-lg-5 col-12 order-2 text-center">
      <img class="profile-img" src="assets/Homepage/principal-ap.jpg" alt="Principal" />
      <div class="person-name">Ananya Pal <br />(Principal)</div>
    </div>
    <div class="col-lg-7 col-12 order-1">
      <div class="message-title">Principal's Message</div>
      <div class="message-text">
        Dear Parents and Students, <br />
        Education is the process of acquiring knowledge, skills, values, and good habits. The purpose of education is to teach students not only “how to make a living” but also “how to live life meaningfully.”<br />
        A teacher should cultivate curiosity in students so they continue learning throughout their lives. In my opinion, it is the right of a child to be wrong — for they learn by making mistakes.<br />
        At River Valley School, all our efforts are directed toward teaching in a way that makes learning enjoyable and engaging. Over the years, the school has demonstrated its vision through excellent board results, achievements in games and sports, and vibrant participation in co-curricular activities.
        
        <span *ngIf="!showPrincipalMessage"></span>
        <span *ngIf="showPrincipalMessage">
          <br />
          The school provides and promotes ample opportunities to foster qualities such as honesty, responsible citizenship, leadership, and tolerance in our students.<br />
          I wish grand success to all our students as they continue to progress by leaps and bounds in life.
        </span>

        <a (click)="showPrincipalMessage = !showPrincipalMessage" class="read-more-link">
          {{ showPrincipalMessage ? '(Read Less)' : '...(Read More)' }}
        </a>
        <!-- <div class="mt-2">Warm Regards,</div> -->
      </div>
      <!-- <div style="padding-left: 5%;">
        <img src="assets/sign_dir.png" alt="">
      </div> -->
    </div>
  </div>
</div>

<app-footer></app-footer>